import Component from "vue-class-component";
import moduleStore from "./store/memberDay";
import Vue from "vue";
import PageState from "./store/state";
import { toast } from "@/utils/util";
import VipCard from "./components/vipCard/vipCard.vue";
import Carousel from "./components/carousel/carousel.vue";
import { Watch } from "vue-property-decorator";
import inobounce from '@/utils/inobounce'

/**components**/
@Component({
  components: {
    VipCard,
    Carousel,
  },
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class memberDayPage extends Vue {
  state = new PageState();
  self: Vue = this;
  vipDays = require("/public/images/welfare/vipdays/header_bg.png");
  vipDaysBig = require("/public/images/welfare/vipdays/header_bg_big.png");
  limitTimeImg = require("/public/images/welfare/vipdays/limit_time.png");
  isStart: Boolean = false;
  
  // tab导航
  tabs: any = ["会员", "声音包", "充电包"];
 
  tabMap = {
    会员: "vip",
    声音包: "voice",
    充电包: "aiText",
  };
  listData: any = []; // 活动全部数据
  existPrevWeek: boolean = false; // 是否存在上周活动
  weekList: any = ["上周", "本周"];
  activeWeek: number = 1; // 当前活动周 默认本周

  timeObj: any = {
    day: "--",
    hour: "--",
    min: "--",
    second: "--",
  };

  initHeight: number = 0;
  initListHeight: number = 0;
  currentTouchStartY: any = 0;

  // 计时器
  timer: any = null;

  get isLastWeek() {
    return this.activeWeek === 0;
  }
  get isNowWeek() {
    return this.activeWeek === 1;
  }
  // 本周是否已开始
  get isNowStart() {
    return this.isNowWeek && this.isStart || !this.existPrevWeek && this.isStart;
  }
  // 显示未开始mask
  get showMask() {
    return !this.isLastWeek && !this.isNowStart;
  }
  // 获取tab类型
  getTabType(item) {
    return this.tabMap[item.tabName];
  }
  // 卡片类型
  getCardType(item) {
    const type = this.getTabType(item);
    return type === "voice" ? "voice" : "vip";
  }

  created(moduleData: IinjectDatas) {
    this.state = <PageState>moduleData.state;
  }
  
  mounted() {
    const mainContent = document.querySelector(".main-content");
    mainContent.addEventListener("touchmove", this.handleTouchMove, true);
    mainContent.addEventListener("touchend", this.handleTouchend, true);
    this.listenScroll();
    //ios刷新H5
    (window as any).getMemberDayActivityInfo = this.getActivityTime;
    // 获取活动初始时间
    this.getActivityTime();
    inobounce.disable()
    
  }
  beforeDestroy() {
    const mainContent = document.querySelector(".main-content");
    mainContent.removeEventListener("touchmove", this.handleTouchMove, true);
    mainContent.removeEventListener("touchend", this.handleTouchend, true);
    clearTimeout(this.timer);
  }
  setInitHeight() {
    // 设置list初始高度
    const el: any = this.$refs.listContent;
    const rect = el.getBoundingClientRect();
    this.initHeight = rect.height;
    const giftListel: any = this.$refs.giftList;
    const giftListrect = giftListel.getBoundingClientRect();
    this.initListHeight = giftListrect.height;
  }
  setTabActive(idx?:any){
    //3个tab 会员; 充电包; 声音包;
    var buttons = document.querySelectorAll(".tab-nav-item");
    const i = idx || 1

    if(idx && typeof idx === "number"){
      
      buttons.forEach((item)=>{
        item.classList.remove('active-tab-nav-item')
      })
      console.log('uttons[i-1]',buttons[i-1]);
      buttons[i-1]?.classList.add("active-tab-nav-item");
    }else{
      // 根据当前可见区域高亮对应按钮
      let arr = []
      buttons.forEach((button) =>{
        var item = button.getAttribute("data-target");
        const targetId = this.tabMap[item];
        var target = document.getElementById(targetId);
        if (target) {
          var rect = target.getBoundingClientRect();
          let distance = rect.bottom - document.querySelector('.tab-nav-box').getBoundingClientRect().bottom-50

          if(distance>=0){
       
            arr.push(button)
          }
        }
      });
      console.log('---arr---',arr);
      if(arr.length>0){
        buttons.forEach((button)=>{
          button.classList.remove("active-tab-nav-item");
        })
        arr[0].classList.add("active-tab-nav-item");
      }
   
    }
  }
  //监听页面滚动
  listenScroll() {
    window.addEventListener(
      "scroll",this.setTabActive,
      true
    );
    
    
  }
  handleTouchMove(e) {
    if (e.touches.length > 1) return;
    if (!this.isLastWeek && !this.isNowStart) return;
    if (!this.currentTouchStartY) {
      this.currentTouchStartY = e.touches[0].pageY;
      return;
    }

    const distance = e.touches[0].pageY - this.currentTouchStartY;

    this.currentTouchStartY = e.touches[0].pageY;
    // this.setBoxheight(-distance);
    this.setTabActive()
    // if (distance < 0) {
    //   console.log("向上滚动");
    //   // this.setBoxheight(-distance);
    // } else {
    //   console.log("向下滚动");
    //   // this.setBoxheight(-distance);
    // }
  }
  handleTouchend() {
    this.currentTouchStartY = 0;
  }

  setBoxheight(distance) {
    const el: HTMLElement = this.$refs.listContent as HTMLElement;
    const rect = el.getBoundingClientRect();
    const newHeight = rect.height + distance;
    const screenHeight = (document.querySelector(".content") as HTMLDivElement)
      .offsetHeight;
    const giftList = this.$refs.giftList as HTMLElement;
    const listrRect = giftList.getBoundingClientRect();
    const topMain = document.querySelector(".guid-img") as HTMLDivElement;
    const Carousel = document.querySelector(".carousel-box") as HTMLDivElement;
    const CarouselHeight = Carousel?.getBoundingClientRect()?.height || 0;
    if (newHeight < screenHeight - (CarouselHeight + 40)) {
      if (giftList.scrollTop <= CarouselHeight + 10) {
        el.style.height = `${newHeight}px`;
        giftList.style.height = `${listrRect.height + distance}px`;
        giftList.style.overflow = "hidden";
        const top = topMain.getBoundingClientRect().top - distance;
        topMain.style.top = top - CarouselHeight + "px";
      }
      if (giftList.scrollTop !== 0) {
        giftList.style.overflow = "auto";
        return;
      }
      if (newHeight < this.initHeight) {
        giftList.style.overflow = "hidden";
        el.style.height = `${this.initHeight}px`;
        giftList.style.height = `${this.initListHeight}px`;
        topMain.style.top = 0 + "px";
        return;
      }
    }
    giftList.style.overflow = "auto";
  }

  // 获取活动时间
  getActivityTime(isApp?) {
      this.$http("getCountdownTime")
        .then((res) => {
          if (res.code === 200) {
            // debugger
            const { startTime, endTime, existPrevWeek } = res.data;
            this.existPrevWeek = !!existPrevWeek;
            // this.existPrevWeek = false;//test

            // const startTime = 1706170300000 // FIXME:
            // const endTime = 1706170706698;
            // this.existPrevWeek = true; 
            
            // 处理时间
            const now = Date.now();
            if (startTime) {
              if (startTime > now) {
                // 未开始
                this.isStart = false;
                this.countdown(startTime);
                if(this.existPrevWeek){
                  this.activeWeek=0
                }
              } else if (endTime && endTime < now) {
                // 已结束
                this.isStart = false;
              } else {
                // 正在进行
                this.isStart = true;
                this.countdown(endTime);
                this.activeWeek = 1
                // this.getVipDayPageFn();
              }
            }
            this.getVipDayPageFn(isApp);
            this.$nextTick(()=>{
              this.setInitHeight();
            })
          }
        })
        .catch((err) => {
          toast("获取活动时间失败");
        });
  }
  // 倒计时
  countdown(time) {
    const endDate: any = new Date(time).getTime();
    const now: any = Date.now();
    const remainTime = endDate - now;
    if (remainTime <= 0) {
      console.log("倒计时结束");
      clearTimeout(this.timer);
      this.getActivityTime()
      // if (toStart) {
      //   // 活动开始 并且在本周选项下
      //   if(this.isNowWeek) {
      //     this.getVipDayPageFn();
      //     this.isStart = true;
      //   }
      // }else if(type === "toEnd"){
      //   // 活动结束
      //   console.log('活动结束-重新请求')
      //   this.getActivityTime()
      // }
      return;
    }
    const days = Math.floor(remainTime / (1000 * 60 * 60 * 24));
    const hours =
      Math.floor((remainTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) < 10
        ? "0" +
          Math.floor((remainTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        : Math.floor((remainTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes =
      Math.floor((remainTime % (1000 * 60 * 60)) / (1000 * 60)) < 10
        ? "0" + Math.floor((remainTime % (1000 * 60 * 60)) / (1000 * 60))
        : Math.floor((remainTime % (1000 * 60 * 60)) / (1000 * 60));
    const seconds =
      Math.floor((remainTime % (1000 * 60)) / 1000) < 10
        ? "0" + Math.floor((remainTime % (1000 * 60)) / 1000)
        : Math.floor((remainTime % (1000 * 60)) / 1000);
    this.timeObj = {
      day: days,
      hour: hours,
      min: minutes,
      second: seconds,
    };
    // this.countdown(time);
    this.timer = setTimeout(() => {
      this.countdown(time);
    }, 1000);
  }
  // 获取会员日配置
  getVipDayPageFn(isApp?) {
    console.log("获取会员日配置");
    this.$http("getVipDayPage", { prevWeek:this.isLastWeek}).then((res) => {
      if (res.code === 200) {
        const result = res.data;
        this.tabs = result.map((obj) => obj.tabName);
        result.forEach((item) => {
          item.showTabList.map((i) => {
            i.tabName = item.tabName;
          });
        });
        this.listData = result;
        this.$nextTick(()=>{
          let tabIdx = isApp?null:1
          this.setTabActive(tabIdx);
        })
        console.log(result, "res");
      }
    });
  }
  // 切换周期
  changeWeekActive(index) {
    this.activeWeek = index;
    this.getVipDayPageFn();
    document.querySelector(".gift-list").scrollTop=0
  }
  scrollDisable = false
  activeChange(item, index) {
    // if (!this.isNowStart) return;
    const targetId = this.tabMap[item];
    const target = document.querySelector("#" + targetId);
    target.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
    this.setTabActive(index+1)
    const giftList = this.$refs.giftList as any;
    giftList.style.overflow = "auto";
  }
  //格式化金额。千位数加逗号
  formatMonex(money) {
    let str = money + "";
    let newStr = "";
    for (let i = 0; i < str.length; i++) {
      newStr += str[i];
      if (i + 4 == str.length && str.length > 2) {
        newStr += ",";
      }
    }
    return newStr;
  }

}
